import css from 'styled-jsx/css'
import { colors } from '../../styles'

export default css`
.ProgressBar {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  background-color: #212121;
}

.progress {
  border-radius: 10px;
  height: 100%;
  background-color: ${colors.darkPurple}
}
`
